export * from './activity.service';
import { ActivityService } from './activity.service';
export * from './adminCompetition.service';
import { AdminCompetitionService } from './adminCompetition.service';
export * from './adminContact.service';
import { AdminContactService } from './adminContact.service';
export * from './adminDevice.service';
import { AdminDeviceService } from './adminDevice.service';
export * from './adminProject.service';
import { AdminProjectService } from './adminProject.service';
export * from './adminSchool.service';
import { AdminSchoolService } from './adminSchool.service';
export * from './adminSurvey.service';
import { AdminSurveyService } from './adminSurvey.service';
export * from './analytics.service';
import { AnalyticsService } from './analytics.service';
export * from './assertion.service';
import { AssertionService } from './assertion.service';
export * from './badge.service';
import { BadgeService } from './badge.service';
export * from './bakedBadge.service';
import { BakedBadgeService } from './bakedBadge.service';
export * from './contactMethods.service';
import { ContactMethodsService } from './contactMethods.service';
export * from './dEC.service';
import { DECService } from './dEC.service';
export * from './dST.service';
import { DSTService } from './dST.service';
export * from './device.service';
import { DeviceService } from './device.service';
export * from './image.service';
import { ImageService } from './image.service';
export * from './issuer.service';
import { IssuerService } from './issuer.service';
export * from './judge.service';
import { JudgeService } from './judge.service';
export * from './onlineEssay.service';
import { OnlineEssayService } from './onlineEssay.service';
export * from './participant.service';
import { ParticipantService } from './participant.service';
export * from './program.service';
import { ProgramService } from './program.service';
export * from './project.service';
import { ProjectService } from './project.service';
export * from './projectDocuments.service';
import { ProjectDocumentsService } from './projectDocuments.service';
export * from './publicBookshop.service';
import { PublicBookshopService } from './publicBookshop.service';
export * from './publicDevice.service';
import { PublicDeviceService } from './publicDevice.service';
export * from './publicSurvey.service';
import { PublicSurveyService } from './publicSurvey.service';
export * from './school.service';
import { SchoolService } from './school.service';
export * from './signUp.service';
import { SignUpService } from './signUp.service';
export * from './teacher.service';
import { TeacherService } from './teacher.service';
export * from './teacherSubject.service';
import { TeacherSubjectService } from './teacherSubject.service';
export * from './userDashboard.service';
import { UserDashboardService } from './userDashboard.service';
export * from './userManager.service';
import { UserManagerService } from './userManager.service';
export * from './userParticipants.service';
import { UserParticipantsService } from './userParticipants.service';
export * from './verbXApi.service';
import { VerbXApiService } from './verbXApi.service';
export const APIS = [ActivityService, AdminCompetitionService, AdminContactService, AdminDeviceService, AdminProjectService, AdminSchoolService, AdminSurveyService, AnalyticsService, AssertionService, BadgeService, BakedBadgeService, ContactMethodsService, DECService, DSTService, DeviceService, ImageService, IssuerService, JudgeService, OnlineEssayService, ParticipantService, ProgramService, ProjectService, ProjectDocumentsService, PublicBookshopService, PublicDeviceService, PublicSurveyService, SchoolService, SignUpService, TeacherService, TeacherSubjectService, UserDashboardService, UserManagerService, UserParticipantsService, VerbXApiService];
